module.exports = __webpack_public_path__ + "img/fettrominas.e224eacb.png";